// @flow
import Vue from 'vue'

/**
 * Require and code split / lazy load buttons / action components
 */
const miscCodeSplit = () => {
  /* DETAIL VIEWS */
  Vue.component('social-share-buttons', () =>
    import(/* webpackChunkName: "misc-ctas" */ '@/components/buttons/social-share-buttons.vue'),
  )

  Vue.component('contextual-help', () =>
    import(/* webpackChunkName: "misc-ctas" */ '@/components/tool-tips/contextual-help.vue'),
  )

  Vue.component('video-expandable-callout', () =>
    import(/* webpackChunkName: "misc-ctas" */ '@/components/videos/video-expandable-callout.vue'),
  )

  Vue.component('youtube-embed', () =>
    import(/* webpackChunkName: "misc-ctas" */ '@/components/videos/youtube-embed.vue'),
  )

  Vue.component('fixed-footer-cta', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/buttons/fixed-footer-cta.vue'),
  )

  Vue.component('content-actions-button', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/buttons/content-actions-button.vue'),
  )

  Vue.component('calendar-button', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/buttons/calendar-button.vue'),
  )

  Vue.component('difficulty-rating', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/videos/difficulty-rating.vue'),
  )

  Vue.component('burn-estimate', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/videos/burn-estimate.vue'),
  )

  Vue.component('stats-community', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/cards/stats-community.vue'),
  )

  Vue.component('stats-member', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/cards/stats-member.vue'),
  )

  Vue.component('unit', () =>
    import(/* webpackChunkName: "misc-ctas" */ '@/components/units/unit.vue'),
  )

  Vue.component('card-grid-unit', () =>
    import(/* webpackChunkName: "misc-ctas" */ '@/components/units/card-grid-unit.vue'),
  )

  /* CONTENT SECTIONS */
  Vue.component('scroll-checklist', () =>
    import(
      /* webpackChunkName: "misc-ctas" */ '@/components/content-sections/scroll-checklist.vue'
    ),
  )

  Vue.component('ingredient-list', () =>
    import(
      /* webpackChunkName: "misc-ctas" */ '../components/content-sections/ingredient-list.vue'
    ),
  )

  /* PLANS */
  Vue.component('plans-scheduled-instances', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/plans/plans-scheduled-instances.vue'),
  )

  Vue.component('program-actions', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/buttons/program-actions.vue'),
  )

  Vue.component('program-instance-delete-button', () =>
    import(
      /* webpackChunkName: "misc-ctas" */ '../components/buttons/program-instance-delete-button.vue'
    ),
  )

  Vue.component('plan-card-add-to-cart-button', () =>
    import(
      /* webpackChunkName: "misc-ctas" */ '../components/plans/plan-card-add-to-cart-button.vue'
    ),
  )

  Vue.component('plan-detail-add-to-cart-button', () =>
    import(
      /* webpackChunkName: "misc-ctas" */ '../components/plans/plan-detail-add-to-cart-button.vue'
    ),
  )

  /* CALENDAR */
  Vue.component('calendar-day-scheduled-item', () =>
    import(
      /* webpackChunkName: "misc-ctas" */ '../components/calendar/calendar-day-scheduled-item.vue'
    ),
  )
  Vue.component('scheduled-instance-actions', () =>
    import(
      /* webpackChunkName: "misc-ctas" */ '../components/buttons/scheduled-instance-actions.vue'
    ),
  )

  Vue.component('detail-complete-button', () =>
    import(
      /* webpackChunkName: "misc-ctas" */ '../components/buttons/completes/detail-complete-button.vue'
    ),
  )

  Vue.component('day-complete-button', () =>
    import(
      /* webpackChunkName: "misc-ctas" */ '../components/buttons/completes/day-complete-button.vue'
    ),
  )

  Vue.component('read-more-expander', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/buttons/read-more-expander.vue'),
  )

  Vue.component('calendar-notes', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/calendar/calendar-notes.vue'),
  )

  /* TOURS */
  Vue.component('tour-card', () =>
    import(/* webpackChunkName: "misc-ctas" */ '../components/tours/tour-card.vue'),
  )

  /* WALLET */
  Vue.component('activate-plus-pass-button', () =>
    import(
      /* webpackChunkName: "misc-ctas" */ '../components/buttons/activate-plus-pass-button.vue'
    ),
  )
}

export default miscCodeSplit
